import React from 'react';
import Hero from '../components/Hero';
import Philosophy from '../components/Philosophy';
import Stats from '../components/Stats';
import FeaturedCourses from '../components/FeaturedCourses';
import WhyChooseLSEM from '../components/WhyChooseLSEM';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import MailingList from '../components/MailingList';

function Home() {
  return (
    <>
      <Hero />
      <Philosophy />
      <FeaturedCourses />
      <Stats />
      <WhyChooseLSEM />
      <Testimonials />
      <FAQ />
      <MailingList />
    </>
  );
}

export default Home;